import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useDeleteComissao() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const deleteComissao = useCallback(
        (id: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/comissao/${id}`,
                method: 'DELETE',
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        deleteComissao,
    };
}
